<template>
  <section class="section --cta">
    <Image :source="content.image" class="section__cta-image" />
    <div class="section__cta">
      <TitleBlock :content="content.titleBlock" />
      <Button
        v-if="content.route || content.link"
        :route="content.route ?? null"
        :link="content.link ?? null"
        :label="content.button"
      />
    </div>
  </section>
</template>

<script>
import TitleBlock from '@/components/blocks/TitleBlock.vue'
import Image from '@/components/global/Image.vue'
import Button from '@/components/small/Button.vue'

export default {
  name: 'CTASection',
  components: { Button, Image, TitleBlock },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
